module.exports = __webpack_public_path__ + "static/media/logo.1960c4ff.svg";